<template>
  <nav class="innerNav">
    <button @click.stop="smoothScroll2('app',$event)" class="toTop">
      <img :src="setImageFullPath('components/innerNav/upToTop.svg')" alt="page topへ">
    </button>
    <button @click.stop="smoothScroll2('Footer', $event)" class="toBottom">
      <img :src="setImageFullPath('components/innerNav/upToBottom.svg')" alt="page footerへ">
    </button>
    <button class="toggleButton" @mouseenter.stop="toggleInnerNav" @touchend.prevent="toggleInnerNav" @keydown.enter="checkInputKey" aria-pressed="true" aria-label="ページ内移動メニューON/OFF">
      <span class="pointerEventNone"></span><span class="pointerEventNone"></span>
    </button>
    <a href="javascript:void(0);" v-for="item in innerNavInfo" v-bind:key="item.id" :class='addLayoutClass(item.id, item.kind)' @click.stop="smoothScroll2(item.id, $event, item.rect.top)" class="anchorLink" role="link">{{item.title}}</a>
  </nav>
</template>

<script>
export default {
  name:'innerNav',
  component:{
  },
  data:function() {
    return {
      innerNavToggle:true,  //true:open false:close
      innerNavHeight:0,
    }
  },
  props:{
    innerNavInfo:{
      title: {
        type:String,
      },
      id:{
        type:String,
      },
      rect:{
        type:Object,
      },
      kind:{
        type:String,
      },
    },
  },
  updated: function() {
    this.resetInnerNav()
  },
  methods: {
    tagId:function(id) {
      return this.$route.path+"/#"+id
    },
    tagJump:function(tagId) {
      document.getElementById(tagId).scrollIntoView({behavior:"smooth"})
    },

/*トグル処理 マウスオーバー*/
    toggleInnerNav:function(e) {
      let myRoot = e.target.parentNode
			if(myRoot.classList.contains('disappearDown')) {
        myRoot.classList.remove('disappearDown')
        myRoot.classList.add('appearUp')

				e.target.setAttribute("aria-pressed", "true")

      }else{
        myRoot.classList.remove('appearUp')
        myRoot.classList.add('disappearDown')

				e.target.setAttribute("aria-pressed", "false")
      }
    },
/*トグル処理 キー*/
		checkInputKey:function(e) {
			if(e.keyCode === 13) {
				this.toggleInnerNav(e)
			}
		},
		eventStop:function(e) {
//			e.stopPropagation()
		},

    resetInnerNav:function() {
      let myRoot = document.querySelector('nav.innerNav')
      myRoot.classList.remove('disappearDown')
      myRoot.classList.add('appearUp')
      this.innerNavToggle = true
      this.innerNavHeight = myRoot.offsetHeight + 'px'

      document.documentElement.style.setProperty('--innerNavHeightTop', (parseInt(this.innerNavHeight) - 44) + 'px')
      let aSetHeight = parseInt(this.innerNavHeight) - 48
      document.documentElement.style.setProperty('--innerNavHeight', aSetHeight + 'px')
    },
    addLayoutClass:function(aId, aKind) {
/*親/子識別*/
      let aClassArray = ""
      aClassArray = (aKind=='h2')? 'parent':'children'
/*案内識別*/
      let aTemp = (aId.indexOf("FunctionInfo") != -1)? 'functionInfo':''

      aClassArray = aClassArray + ' ' + aTemp
      return aClassArray
    },
  },
}
</script> 

<style>
</style>
